<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间.空间名称')">
                <a-input v-model="queryParam.spaceName" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间.是否免费')">
                <a-select v-model="queryParam.isFree" allowClear>
                  <a-select-option :value="1">{{$t('空间.免费')}}</a-select-option>
                  <a-select-option :value="0">{{$t('空间.收费')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('空间.状态')">
                <a-select v-model="queryParam.status" allowClear>
                  <a-select-option :value="1">{{$t('空间.启用')}}</a-select-option>
                  <a-select-option :value="0">{{$t('空间.禁用')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['space:space:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['space:space:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
      </div>

      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="coverImage" slot-scope="text, record">
          <img v-if="record.coverImage" :src="record.coverImage" style="width:60px;height:60px;object-fit:cover;border-radius:4px;" />
          <span v-else>-</span>
        </span>
        <span slot="mainImage" slot-scope="text, record">
          <img v-if="record.mainImage" :src="record.mainImage" style="width:60px;height:60px;object-fit:cover;border-radius:4px;" />
          <span v-else>-</span>
        </span>
        <span slot="isFree" slot-scope="text, record">
          <a-tag :color="record.isFree === 1 ? 'green' : 'orange'">
            {{ record.isFree === 1 ? $t('空间.免费') : $t('空间.收费') }}
          </a-tag>
        </span>
        <span slot="price" slot-scope="text, record">
          {{ record.isFree === 1 ? '-' : (record.price ? '¥' + record.price : '-') }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 1 ? 'green' : 'red'">
            {{ record.status === 1 ? $t('空间.启用') : $t('空间.禁用') }}
          </a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['space:space:edit']">
            <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['space:space:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 新增/编辑表单 -->
    <create-form ref="createForm" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { pageSpace, delSpace } from '@/api/space/space'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm'

export default {
  name: 'Space',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      queryParam: {
        spaceName: undefined,
        isFree: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('空间.空间名称'), dataIndex: 'spaceName' , width: 90},
        { title: this.$t('空间.封面图'), dataIndex: 'coverImage', scopedSlots: { customRender: 'coverImage' }, width: 90 },
        { title: this.$t('空间.空间主图'), dataIndex: 'mainImage', scopedSlots: { customRender: 'mainImage' }, width: 90 },
        { title: this.$t('空间.是否免费'), dataIndex: 'isFree', scopedSlots: { customRender: 'isFree' }, width: 100 },
        { title: this.$t('空间.购买价钱'), dataIndex: 'price', scopedSlots: { customRender: 'price' }, width: 100 },
        { title: this.$t('空间.状态'), dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: this.$t('空间.排序'), dataIndex: 'sort', width: 80 },
        { title: this.$t('空间.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 160 },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 160, fixed: 'right' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      pageSpace(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        spaceName: undefined,
        isFree: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current) {
      this.queryParam.pageNum = current
      this.getList()
    },
    handleAdd() {
      this.$refs.createForm.handleAdd()
    },
    handleUpdate(row) {
      this.$refs.createForm.handleUpdate(row)
    },
    handleDelete(row) {
      const ids = row.id || this.selectedRowKeys.join(',')
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk: () => {
          return delSpace([{ id: row.id || ids }]).then(() => {
            this.$message.success(this.$t('通用.文本.删除成功'))
            this.getList()
          })
        }
      })
    }
  }
}
</script>
